import React, { ReactNode } from 'react'
import Item from './item'
import { BreadcrumbContainer } from './atoms'

const Breadcrumb = ({ separator, children }: { separator: string; children: ReactNode }) => {
  return <BreadcrumbContainer separator={separator}>{children}</BreadcrumbContainer>
}

Breadcrumb.Item = Item
export default Breadcrumb
